__turbopack_context__.v({
  "answers-list": "_qX_pG_answers-list",
  "answers-list-multiple": "_qX_pG_answers-list-multiple",
  "button-container": "_qX_pG_button-container",
  "chip-container": "_qX_pG_chip-container",
  "close-title": "_qX_pG_close-title",
  "content-container": "_qX_pG_content-container",
  "continue-button": "_qX_pG_continue-button",
  "eyebrow": "_qX_pG_eyebrow",
  "font-align-center": "_qX_pG_font-align-center",
  "font-align-left": "_qX_pG_font-align-left",
  "font-align-right": "_qX_pG_font-align-right",
  "font-black": "_qX_pG_font-black",
  "font-blue": "_qX_pG_font-blue",
  "font-gery": "_qX_pG_font-gery",
  "font-white": "_qX_pG_font-white",
  "got-it-button": "_qX_pG_got-it-button",
  "icon-container": "_qX_pG_icon-container",
  "info-btn": "_qX_pG_info-btn",
  "loader-text": "_qX_pG_loader-text",
  "multiple-disclaimer": "_qX_pG_multiple-disclaimer",
  "progress-container": "_qX_pG_progress-container",
  "result-section": "_qX_pG_result-section",
  "section": "_qX_pG_section",
  "selected-topic": "_qX_pG_selected-topic",
  "sub-title": "_qX_pG_sub-title",
  "subnav-outer-container": "_qX_pG_subnav-outer-container",
  "text-container": "_qX_pG_text-container",
  "topic-chip": "_qX_pG_topic-chip",
  "topic-container": "_qX_pG_topic-container",
});
